import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Binary Expressions",
description: "Learn how binary expression concepts are handled in Freon and how to define operator symbols such as plus, minus, multiply, and divide in .edit files.",
tags: [ "binary expressions", "operator symbols", "expression concepts", "projectional editor", "editor definition", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.357Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};